'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React from 'react';

import PropTypes from 'prop-types';

import { getColor } from 'utils';

import styles from './ProductCategory.module.scss';

const ProductCategory = ({
    category,
    categoryDetailIntro,
    subcategorySliders,
    blocks,
}) => {
    const pageBackgroundColor = category?.backgroundColor;

    return (
        <div
            className={styles.productCategoryPage}
            style={{
                '--page-bg-color': pageBackgroundColor
                    ? getColor(pageBackgroundColor)
                    : undefined,
            }}
        >
            {categoryDetailIntro}
            {subcategorySliders && subcategorySliders.length > 0 && (
                <div className={styles.productRows}>
                    {subcategorySliders.map((slider, i) => {
                        return (
                            <React.Fragment key={i}>
                                {slider}
                                {i < subcategorySliders.length - 1 && (
                                    <div className={styles.rowDivider} />
                                )}
                            </React.Fragment>
                        );
                    })}
                </div>
            )}
            {blocks}
        </div>
    );
};

ProductCategory.propTypes = {
    category: PropTypes.object,
    categoryDetailIntro: PropTypes.object,
    subcategorySliders: PropTypes.array,
    blocks: PropTypes.array,
};

export default ProductCategory;
